import React from "react";
import { findMenuTitleByPath } from "./menu/menuUtils";
import { MenuItem } from "../menu/menuTypes";

export interface TitlePageProps {
  pathname: string;
  menu: MenuItem[];
}

const TitlePage: React.FC<TitlePageProps> = ({ pathname, menu }) => {
  const title = findMenuTitleByPath(menu, pathname);
  return <span className="section-name">{title}</span>;
};

export default TitlePage;
